/* eslint-disable no-plusplus */
import { call, putResolve, select, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import get from 'lodash/get';
import areaInSquareFeet from '../api/areaInSquareFeet';
import {
  addRoomMeasure,
  addRoomSuccess,
  updateCarpetPrice,
  updateRoomPrice,
} from '../actions';
import { updateStepPrice } from '../actions/stepsAction';
import { updatePath } from '../actions/pathActions';
import { roomMeasureSelector } from '../selectors/roomMeasure';
import { configuratorChoices, configuratorOptions } from '../selectors/configurator';
import { selectSelectedCarpetChoice, totalCarpetPrice } from '../selectors/pricing';
import { findTaggedValue } from '../utils/tags';
import getSelectedCarpetChoice from '../utils/getSelectedCarpetChoice';
import { trackEnterRoomsAddRoom } from '../utils/analytics/trackEvents';
import { EXTRA_AREA } from '../utils/constants';
import safeSaga from './safeSaga';

function* custompayload(paycharge) {
  const choices = yield select(configuratorChoices);
  const options = yield select(configuratorOptions);
  const choicePrices = yield select(selectSelectedCarpetChoice);
  const { measure } = yield select(roomMeasureSelector);

  const selectedCarpetChoice = yield getSelectedCarpetChoice(options, choices);
  const rollWidth = selectedCarpetChoice
    ? findTaggedValue(selectedCarpetChoice.tags, 'carpetwidth') : 12;
  const selectedCarpetPrice = choicePrices?.priceSquareYard || 0;
  const padPrice = measure[0]?.padPrice || 0;

  const length = yield Number(paycharge.length);
  const width = yield Number(paycharge.width);
  const roomId = yield uuidv4();
  const price = yield selectedCarpetPrice;
  if (get(paycharge, 'sqFt')) {
    // TODO @dylan I beleive we will refactore this right ?
    const allCarpetPrice = yield select(totalCarpetPrice);
    const sqFt = yield Math.round(paycharge.sqFt); // no extra area comes from redux
    const carpetPadPrice = yield padPrice > 0 ? (padPrice * sqFt).toFixed(2) : padPrice;
    const squarePrice = yield ((sqFt / 9) * price).toFixed(2);
    const totalPrice = yield squarePrice + carpetPadPrice;
    yield putResolve(updateCarpetPrice(allCarpetPrice));
    // we need to update price
    yield putResolve(updateRoomPrice(selectedCarpetPrice));
    yield putResolve(updateStepPrice(selectedCarpetPrice));
    return {
      payload: {
        id: roomId,
        room: yield paycharge.room,
        length,
        width,
        sqFt,
        price,
        squarePrice,
        carpetPadPrice,
        totalPrice,
      },
    };
  }
  const data = yield call(areaInSquareFeet, roomId, length, width, rollWidth);
  const sqFt = yield Math.round(Number(data.areaInSquareFeet) * EXTRA_AREA);
  const squarePrice = yield ((sqFt / 9) * price).toFixed(2);
  const carpetPadPrice = yield padPrice > 0 ? (padPrice * sqFt).toFixed(2) : padPrice;
  const totalPrice = yield squarePrice + carpetPadPrice;

  trackEnterRoomsAddRoom(roomId, Math.round(sqFt));

  return {
    payload: {
      id: roomId,
      room: yield paycharge.room,
      length,
      width,
      sqFt: Math.round(sqFt),
      price,
      squarePrice,
      carpetPadPrice,
      totalPrice
    },
  };
}

function* roomNameValidation(room, currentTable) {
  const measureObj = {};
  let sameRoomNameCount = 1;
  const currentRoom = room.trim();
  for (let i = 0; i < currentTable.length; i++) {
    if (currentTable[i].room === currentRoom) {
      sameRoomNameCount += 1;
      break;
    }
  }

  if (sameRoomNameCount === 1) {
    return yield currentRoom;
  }
  for (let i = 0; i < currentTable.length; i++) {
    const addedInt = currentTable[i].room.match(/(\d+)/);
    if (addedInt) {
      const verifiedRoom = currentTable[i].room;
      const extractedInt = parseInt(addedInt[0], 10);
      const extractedSting = verifiedRoom.replace(extractedInt, '');
      if (extractedSting === currentRoom) measureObj[verifiedRoom] = extractedInt;
    }
  }
  const nextRoomNumber = Math.max(...Object.values(measureObj)) > 1 ? Math.max(...Object.values(measureObj)) : 1;

  return yield currentRoom.concat(nextRoomNumber + 1);
}

export function* addroom(action) {
  const data = action.payload;
  const payloads = Array.isArray(data) ? data : [data];
  for (let i = 0; i < payloads.length; i++) {
    const { measure } = yield select(roomMeasureSelector);
    const roomName = yield roomNameValidation(payloads[i].room, measure);
    const { payload } = yield custompayload(payloads[i]);
    const newPayload = yield { ...payload, room: roomName };
    yield putResolve(addRoomSuccess(newPayload));
    yield putResolve(updatePath());
  }
}

export function* addRoomSaga() {
  yield takeEvery(addRoomMeasure.toString(), safeSaga(addroom));
}
